module.exports = __webpack_public_path__ + "media/Slide15.716ea603.mp3";